const ONE_MINUTE_IN_MS = 60_000
export const CHAT_TIMEOUT_MESSAGE = 2.5 * ONE_MINUTE_IN_MS
export const END_CHAT_TIMEOUT = 0.5 * ONE_MINUTE_IN_MS
export const CALENDLY_PORTAL_ID = 'calendly'
export const EMBEDDED_CHAT_KEY = 'embedded'
export const EMBEDDED_CHAT_VALUE = 'yes'
export const TEMPLATE_PAGE_CHAT_KEY = 'isTemplatePage'
export const TEMPLATE_PAGE_CHAT_VALUE = 'yes'
export const PREFIX_EMBEDDED_CHAT = 'embedded-chat-'
export const MAX_LENGTH_POPUP_MESSAGE = 400
export const DEFAULT_POPUP_DELAY = 0
export const DEFAULT_AUTO_CLOSE_DELAY = 10
export const DEFAULT_POPUP_MESSAGE =
  'Hi, if you need anything, you can chat with our Assistant here!'
export const SUPPORT_CHAT_KEY = 'isSupportChat'
export const SUPPORT_CHAT_VALUE = 'true'
